<template>
	<div>
		<div v-if="org.personal" class="subtle-box p-box-more t-center" >
			<h1>There is only one you.</h1>
			<p>You can't add team members to your personal account.</p>
			<p><b>Want to share configs with others?</b> Start a new organisation:</p>
			<p><router-link :to="{name:'orgs'}" class="btn btn-a">Manage organisations</router-link></p>
		</div>
		<div v-else >

			<p>
				<button class="btn-a" v-on:click="openInviteEditor(org)"  ><i class="fa fa-envelope btn_icon"></i>Invite a new user</button>
			</p>
		

			<div class="raised-box" >

				<List
					:loading="!(users_loaded && invites_loaded)"
					:results="team_list"
					:columns="[
						{
							usericon:1,
						},
						{
							label:'Name',
							name:'name',
						},
						{
							label:'Email',
							name:'email',
						},
						{
							label:'Status',
							name:'status',
						},
						{
							label:'Options',
							buttons : (item) => {

								if((item.user||{}).id){
									return [
										{
											text : 'Remove user',
											confirm:'Are you sure you want to remove this user?',
											class : 'btn-outline-warning' + ( item.loading ? ' _btn_submitting-grey' :'' ),
											action : ()=>{ removeUser(item.user); },
										},
									];
								}

								return [
									{
										text : 'Cancel invite',
										confirm:'Are you sure you want to cancel this invite?',
										class : 'btn-outline-warning' + ( item.loading ? ' _btn_submitting-grey' :'' ),
										action : ()=>{ cancelInvite(item.invite); },
									},
								];
							},
						},
					]"
				/>
			</div>
		</div>
	</div>
</template>

<script>

	import List from '../../components/List';
	import AddInvite from '../../modals/AddInvite';

	export default {
		components: {List},
		props : [
			'org',
		],
		data() {
			return {
        users : [],
				invites : [],
				users_loaded : false,
				invites_loaded : false,
			};
		},
		mounted(){
			this.refreshUsers();
			this.refreshInvitations();
		},
		computed:{
			ordered_invites : function(){
				return this.invites.reduce((a,c)=>{
							if( !a.find( x => x.email == c.email ) ){
								a.push(c);
							}
							return a;
						},[]);
			},
			team_list : function(){
				var self = this;
				return [
					...this.invites.map((i)=>({
											invite : i,
											name : [i.first_name,i.last_name].join(' '),
											first_name : i.first_name,
											last_name : i.last_name,
											email : i.email,
											status : 'Invitation sent ' + ( i.created_at ? self.dsplDate(i.created_at) : '' ),
											loading : i._loading,
										})),
					...this.users.map((u)=>({
											user : u,
											name : [u.first_name,u.last_name].join(' '),
											first_name : u.first_name,
											last_name : u.last_name,
											email : u.email,
											status : 'Active user',
											loading : u._loading,
										})),
				].sort((a,b)=>{
					if(a.name == b.name){
						return 0;
					}else if(a.name > b.name){
						return 1;
					}
					return -1;
				});
			},
		},

		methods:{
			formatDate(str){
				var xstr = str.split(/[- :]/);
				// var d = new Date(Date.UTC(xstr[0], xstr[1]-1, xstr[2], xstr[3], xstr[4], xstr[5]));
				return [xstr[2],xstr[1],xstr[0]].join('/');
			},
			refreshUsers(){
				var self = this;
				if(!this.org) return;

				return api.call('get','/orgs/'+this.org.id+'/users')
					.then((result)=>{ 
						self.users = result.data;
						self.users_loaded = true;
					});

			},

			refreshInvitations(){
				var self = this;
				if(!this.org) return;

				return api.call('get','/invites')
					.then((result)=>{ 
						self.invites = result.data.filter(x=>x.org_id==self.org.id);
						self.invites_loaded = true;
					});

			},

			removeUser(user){
				var self = this;
				this.users = this.users.map((u)=>u.id==user.id?Object.assign(u,{_loading:true}):u);
				api.update('user',user.id,{action:'kick',organisation_id:self.organisation.id})
					.then(()=>{
						return self.refreshUsers();
					});
			},


			cancelInvite(invite){
				var self = this;
				this.invites = this.invites.map((i)=>i.id==invite.id?Object.assign(i,{_loading:true}):i);
				api.delete('invite',invite.id)
					.then(()=>{
						return self.refreshInvitations();
					});
			},

			removeUserModal(user){
				var self = this;
				this.users = this.users.map((u)=>u.id==user.id?Object.assign(u,{_loading:true}):u);
				Event.$emit('confirm', {
					confirm : 'Remove user ('+user.email+') from '+this.organisation.name+'?',
					onConfirm(){
						api
						.update('user',user.id,{action:'kick',organisation_id:self.organisation.id})
						.then(()=>{
							return self.refreshUsers();
						})
					},
				});
			},

			cancelInviteModal(invite){
				var self = this;
				this.invites = this.invites.map((i)=>i.id==invite.id?Object.assign(i,{_loading:true}):u);
				Event.$emit('confirm', {
					confirm : 'Cancel the invite sent to '+invite.email+'?',
					onConfirm(){
						api
						.delete('invite',invite.id)
						.then(()=>{
							return self.refreshInvitations();
						})
					},
				});
			},

			openInviteEditor(){
				Event.$emit('modal-open', {
					component : AddInvite,
					props : {
						invites : this.invites,
						org : this.org,
					}
				});
			},

		}
	}

</script>